import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { StatCard } from "@/components/common/StatCard";
import { Badge } from "@/components/common/DataTable";
import { Activity, Database, Server } from "lucide-react";

export default function MonitoringPage() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/v1/admin/monitoring").then((r) => setData(r.data.data)).catch(() => {}); }, []);

  const fmt = (s) => { const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60); return `${h}h ${m}m`; };

  return (
    <div data-testid="monitoring-page">
      <PageHeader title="Platform Monitoring" subtitle="Service health & system metrics" />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-7">
        <StatCard testid="stat-uptime" label="Uptime" value={data ? fmt(data.uptimeSeconds) : "—"} icon={Activity} />
        <StatCard testid="stat-db" label="Database" value={data?.database === "connected" ? "Connected" : "—"} icon={Database} accent="text-emerald-500" />
        <StatCard testid="stat-api" label="API" value={data?.services?.api || "—"} icon={Server} accent="text-sky-500" />
      </div>
      <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm">
        <h3 className="font-semibold text-slate-800 mb-4">Collection Counts</h3>
        <div className="flex flex-wrap gap-3">
          {Object.entries(data?.collections || {}).map(([k, v]) => (
            <div key={k} className="px-4 py-2 rounded-lg bg-slate-50 border border-slate-200">
              <span className="text-sm text-slate-500 capitalize mr-2">{k}</span>
              <Badge color="teal">{v}</Badge>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
